import { DuplicateIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Button, List, ListItem, Typography } from '@global-engineering-shared/gweb-material-ui';

type IdListClassKeyType = 'list' | 'listItem' | 'button';
type ClassNameMap<T extends string> = Record<T, string>;

type IdListProps = {
  ids: Array<string>;
  classes?: Partial<ClassNameMap<IdListClassKeyType>>;
};

const IdList = ({ ids, classes }: IdListProps) => {
  return (
    <List classes={{ root: classes?.list }}>
      <Button
        startIcon={<DuplicateIcon />}
        onClick={() => navigator.clipboard.writeText(ids.join(', '))}
        variant="text"
        color="primary"
        classes={{ root: classes?.button }}
      >
        Copy ID{ids.length > 1 && 's'} to Clipboard
      </Button>
      {ids.map((id) => (
        <ListItem key={id} classes={{ root: classes?.listItem }}>
          {id}
        </ListItem>
      ))}
    </List>
  );
};

export const getNoDraftsDialogMessage = (
  spaceIdsWithoutDraft: Array<string>,
  classes?: Partial<ClassNameMap<IdListClassKeyType>>
) => {
  const noDraftsCount = spaceIdsWithoutDraft.length;

  if (noDraftsCount === 1) {
    return (
      <Typography color="textPrimary" variant="body2">
        Something went wrong with 1 entity with the following ID and <strong>there is not</strong> a
        draft associated with it:
        <IdList ids={spaceIdsWithoutDraft} classes={classes} />
      </Typography>
    );
  }

  return (
    <Typography color="textPrimary" variant="body2">
      Something went wrong with {noDraftsCount} entities with the following IDs and{' '}
      <strong>there are not</strong> drafts associated with them:
      <IdList ids={spaceIdsWithoutDraft} classes={classes} />
    </Typography>
  );
};

export const getDraftsDialogMessage = (spaceIdsWithDraft: Array<string>) => {
  const draftsCount = spaceIdsWithDraft.length;

  if (draftsCount === 1) {
    return (
      <Typography color="textPrimary" variant="body2">
        1 entity has a draft associated with it
      </Typography>
    );
  }

  return (
    <Typography color="textPrimary" variant="body2">
      {draftsCount} entities have drafts associated with them
    </Typography>
  );
};
